import { motion } from "framer-motion";
import ic from './ic.svg'
import './info-block.scss'

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.7,
            delay: i * 0.15,
            ease: "easeOut"
        }
    })
};

export default function InfoBlock() {
    return (
        <motion.div
            className="info-block"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.24 }}
        >
            <motion.div
                className="info-block__top"
                variants={fadeUp}
                custom={0}
            >
                <motion.h2 className="info-block__title" variants={fadeUp} custom={0}>
                    Trade Without Borders
                </motion.h2>
                <motion.span className="info-block__subtitle" variants={fadeUp} custom={0.25}>
                    Access global markets including stocks, cryptocurrencies, indices, and commodities — all in one powerful platform. Fast registration, quick order execution, and dedicated support every step of the way.
                </motion.span>
            </motion.div>

            <div className="info-block__wrapper container">
                {[
                    "User-friendly WEB-Trader platform",
                    "Seamless access to global exchanges like NASDAQ, LSE, and top crypto assets",
                    "Funds protection and 24/7 uptime"
                ].map((text, idx) => (
                    <motion.div
                        className="info-block__card"
                        key={text}
                        variants={fadeUp}
                        custom={idx + 1}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                        whileHover={{ scale: 1.04, boxShadow: "0 2px 22px #fd532f22" }}
                        transition={{ type: "spring", stiffness: 330, damping: 18 }}
                    >
                        <img src={ic} alt="" />
                        <span className="info-block__text">{text}</span>
                    </motion.div>
                ))}
            </div>

            <motion.div
                className="info-block__bottom"
                variants={fadeUp}
                custom={4}
            >
                <motion.h2 className="info-block__title" variants={fadeUp} custom={4}>
                    Your Security Comes First
                </motion.h2>
                <motion.span className="info-block__subtitle" variants={fadeUp} custom={4.25}>
                    We prioritize the safety of your funds with robust encryption, segregated accounts, and 24/7 monitoring. Trade with peace of mind.
                </motion.span>
            </motion.div>
        </motion.div>
    );
}
